<template>
 <div>
    <components
      :leaseInfoParams="renderData.model.leaseInfoParams"
      :maitenaceParams="renderData.model.maitenaceParams"
      :tableDataFrom="renderData.model.tableDataFrom"
      :is="component"
      :renderData="renderData"
      :topPreviewModel="renderData.model.topPreviewModel"
      class="component"
      ref="components"
      @cancel="cancel"
      @previousStep="previousStep"
      @confirm="confirm"
      @submit="submit"
      @setStepList="setStepList"
      @continueBuild="continueBuild"
    ></components>
 </div>
</template>
<script>
import selectOrderConfig from '../config/selectOrder'
import leaseSetupConfig from '../config/leaseSetup'
import boundVehicleConfig from '../config/boundVehicle'
import moment from 'moment'
import {
  getLeaseDetail,
  getLeaseOrderList,
} from '@/api/domain/orders'

export default {
  components: {
  },
  props: {
    component: {
      type: Object,
      default: () => ({}),
    },
    // eslint-disable-next-line vue/no-unused-properties
    active: {
      type: Number,
      default: 0,
    },
  },
  data() {
    const {
      selectOrderList,
      selectOrderModel,
      selectOrderRules,
    } = selectOrderConfig.call(this)
    const {
      ladderSchemeConfig,
      leaseSetupList,
      leaseSetupModel,
      leaseSetupRules,
    } = leaseSetupConfig.call(this)
    const {
      boundVehicleList,
      boundVehicleModel,
    } = boundVehicleConfig.call(this)
    return {
      ladderSchemeConfig,
      // 选择主订单
      selectOrderList,
      selectOrderModel,
      selectOrderRules,
      // 租赁设置
      leaseSetupList,
      leaseSetupModel,
      leaseSetupRules,
      // 绑定车辆
      boundVehicleList,
      boundVehicleModel,
      // 租赁信息
      leaseInfoParams: {
        signDate: moment(new Date()).format('YYYY-MM-DD HH:mm:ss'), // 签署日期
        category: 1, // 类别
        startStopDate: [], // 起止日期
        presentDays: '', // 赠送天数
        freedomCycle: '', // 免租周期
      },
      maitenaceParams: { // 维保方案
        providerId: '',
        maintenancePlanId: '',
      },
      defaultTable: [
        {
          fundType: 1,
          items: [],
          payMode: '',
          feeConfig: {
            feePiecewiseCalculation: {
              isOpen: 0,
              feePiecewiseConfigList: [],
              unit: 1, // 1 月
            },
          },
          complete: false,
          dailyRule: '', // 不足月日租金规则
          advancePayment: '', // 发车前收款
        },
        {
          fundType: 2,
          items: [],
          payMode: '',
          feeConfig: {
            feePiecewiseCalculation: {
              isOpen: 0,
              feePiecewiseConfigList: [],
              unit: 1, // 1 月
            },
          },
          complete: false,
          dailyRule: '', // 不足月日租金规则
          advancePayment: '', // 发车前收款
        },
      ],
      tableDataFrom: {
        tableData: [],
      }, // 支付计划
      // 当前页面数据
      topPreviewModel: {},
    }
  },
  watch: {
    'renderData.model.vehicleModelModel.modelId': {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.renderData.model.m_addVehicleModel.carInfoList = []
        }
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    renderData() {
      const {
        selectOrderList,
        selectOrderModel,
        selectOrderRules,
        leaseSetupList,
        leaseSetupModel,
        leaseSetupRules,
        topPreviewModel,
        boundVehicleList,
        boundVehicleModel,
        leaseInfoParams,
        maitenaceParams,
        tableDataFrom,
        ladderSchemeConfig,
        defaultTable,
      } = this
      return {
        list: {
          ...selectOrderList,
          ...leaseSetupList,
          ...boundVehicleList,
        },
        model: {
          ...selectOrderModel,
          ...leaseSetupModel,
          ...boundVehicleModel,
          topPreviewModel,
          leaseInfoParams,
          maitenaceParams,
          tableDataFrom,
          ladderSchemeConfig,
          defaultTable,
        },
        rules: {
          ...selectOrderRules,
          ...leaseSetupRules,
        },
      }
    },
  },
  mounted() {
    this.getRouterQuery()
  },
  methods: {
    // 客户名称切换
    // eslint-disable-next-line vue/no-unused-properties
    customerNameChange(id) {
      const { selectOrderFormModel, selectOrderTextModel } = this.renderData.model

      // 主订单id禁用逻辑
      this.$set(selectOrderFormModel, 'entRentOrderId', '')
      this.$refs.components.$refs?.baseInfoInfo?.setItemData({ elConfigKey: 'list', key: 'entRentOrderId', data: [] })
      this.$set(selectOrderFormModel, 'customerId', id)
      for (const key in selectOrderTextModel) {
        if (key !== 'customerType') {
          selectOrderTextModel[key] = ''
        }
      }
      // 获取主订单Id列表
      id && this.getTableData()
      // 主订单赋值
      this.$refs.components.$refs?.baseInfoInfo?.setItemData({ elConfigKey: 'disabled', key: 'entRentOrderId', data: id === '' })
    },
    // 请求数据table
    async getTableData() {
      const { selectOrderFormModel } = this.renderData.model
      const params = {
        customerId: selectOrderFormModel.customerId,
        pageNum: 1,
        pageSize: 999,
        state: 2,
      }
      const { data } = await getLeaseOrderList(params)
      this.$refs.components.$refs.baseInfoInfo.setItemData({ elConfigKey: 'list', key: 'entRentOrderId', data: data.items || [] })
    },
    // 清空租赁数据
    // eslint-disable-next-line vue/no-unused-properties
    clearLeaseSetupModel() {
      const { selectOrderFormModel, leaseSchemeModel, vehicleModelModel, vehicleSelectionModel, tableDataFrom, defaultTable } = this.renderData.model
      const leaseInfoParamsConfig = {
        signDate: moment(new Date()).format('YYYY-MM-DD HH:mm:ss'), // 签署日期
        category: 1, // 类别
        startStopDate: [], // 起止日期
        presentDays: '', // 赠送天数
        freedomCycle: '', // 免租周期
      }
      this.$set(selectOrderFormModel, 'customerId', '')
      this.$set(selectOrderFormModel, 'entRentOrderId', '')
      this.$set(leaseSchemeModel, 'planId', 0)
      this.$set(vehicleModelModel, 'modelId', '')
      this.$set(vehicleSelectionModel, 'readyLeaseState', '')
      this.$set(vehicleSelectionModel, 'plateNo', '')
      this.$set(this.renderData.model, 'leaseInfoParams', leaseInfoParamsConfig)
      this.$set(tableDataFrom, 'tableData', [...defaultTable])
    },
    continueBuild() {
      this.$emit('continueBuild')
    },
    setStepList(active) {
      this.$emit('setStepList', active, this.renderData)
    },
    /** ---------------------------*租赁设置*------------------------* */
    // 租赁方案选择
    // eslint-disable-next-line vue/no-unused-properties
    planChange(id) {
      this.$refs.components.planChange(id)
    },
    /** ---------------------------*选择主订单*------------------------* */
    // 获取路由参数
    getRouterQuery() {
      const { customerId, customerName, entRentOrderId } = this.$route.query
      if (customerId) {
        this.$set(this.renderData.model.selectOrderFormModel, 'customerId', customerId)
        this.$refs.components.$refs?.baseInfoInfo?.setItemData({ elConfigKey: 'disabled', key: 'entRentOrderId', data: false })
      }
      if (customerName) {
        this.$set(this.renderData.model.selectOrderTextModel, 'customerName', customerName)
      }
      if (entRentOrderId) {
        this.$set(this.renderData.model.selectOrderFormModel, 'entRentOrderId', entRentOrderId)
        this.$refs.components?.$refs?.baseInfoInfo && this.$refs.components.$refs.baseInfoInfo.setItemData({ elConfigKey: 'disabled', key: 'entRentOrderId', data: false })
        this.getDetails(Number(entRentOrderId))
      }
    },
    // 详情页请求数据
    async getDetails(id) {
      const { selectOrderTextModel, selectOrderFormModel } = this.renderData.model
      if (id) {
        const { data: { orderInfo } } = await getLeaseDetail({
          id,
        })

        selectOrderTextModel.id = orderInfo.id
        selectOrderTextModel.customerName = orderInfo.customerName
        if (orderInfo.contractStartDate && orderInfo.contractEndDate) {
          selectOrderTextModel.contractStartEndTime = `${orderInfo.contractStartDate} 至 ${orderInfo.contractEndDate}`
        }
        selectOrderTextModel.carTotalNum = orderInfo.carTotalNum
        selectOrderTextModel.rentedCarNum = orderInfo.rentedCarNum
        selectOrderTextModel.gmtCreate = orderInfo.gmtCreate
        selectOrderTextModel.deptName = orderInfo.deptName
        selectOrderFormModel.deptId = orderInfo.deptId
        this.handelToppreview()
      } else {
        for (const key in selectOrderTextModel) {
          if (key !== 'customerType') {
            selectOrderTextModel[key] = ''
          }
        }
      }
    },
    handelToppreview() {
      const { selectOrderTextModel } = this.renderData.model

      this.renderData.model.topPreviewModel.companyName = selectOrderTextModel.companyName
      this.renderData.model.topPreviewModel.customerName = selectOrderTextModel.customerName
      this.renderData.model.topPreviewModel.entRentOrderId = selectOrderTextModel.id
      this.renderData.model.topPreviewModel.deptName = selectOrderTextModel.deptName
    },
    // 新增主订单
    // eslint-disable-next-line vue/no-unused-properties
    tipsClick() {
      this.$router.push({
        path: `/car_to_lease/forRentSignContract/createMasterOrder?date=${new Date().getTime()}`,
      })
    },
    // 客户姓名模糊搜索
    // eslint-disable-next-line vue/no-unused-properties
    customerNameRemoteMethod(val, id = '') {
      this.$refs.components.customerNameRemoteMethod(val, id)
    },
    //
    cancel() {
      this.$emit('cancel')
    },
    previousStep() {
      this.$emit('previousStep')
    },
    confirm(state) {
      this.$refreshParent() // 刷新父元素
      this.$emit('confirm', state)
    },
    submit() {
      this.$emit('submit')
    },
  },
}
</script>

<style scoped lang='scss'>
::v-deep .qs-scrollerBox{
  margin-right: 0;
}
</style>
